import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import styles from './pagination.css.js';

const PaginationWrapper = styled.div`${styles}`;

const propTypes = {
    items: PropTypes.array.isRequired,
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number
}

const defaultProps = {
    initialPage: 1,
    pageSize: 10
}

class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = { pager: {} };

        this.setPrevious = this.setPrevious.bind(this);
        this.setNext = this.setNext.bind(this);
    }

    componentWillMount() {
        // set page if items array isn't empty
        if (this.props.items && this.props.items.length) {
            this.setPage(this.props.initialPage);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // reset page if items array has changed
        if (this.props.items !== prevProps.items) {
            this.setPage(this.props.initialPage);
        }

        if (JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
            return this.setPage(this.props.initialPage);
        }

        if (this.props.sorting !== prevProps.sorting || this.props.searchValue !== prevProps.searchValue) {
            return this.setPage(this.props.initialPage);
        }
    }

    setPage(page) {
        var { items, pageSize } = this.props;
        var pager = this.state.pager;

        // if (page < 1 || page > pager.totalPages) {
        //     console.log('page < 1 || page > pager.totalPages');
        //     return;
        // }

        // get new pager object for specified page
        pager = this.getPager(items.length, page, pageSize);

        // get new page of items from items array
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update state
        this.setState({ pager: pager });

        // call change page function in parent component
        this.props.onChangePage(pageOfItems);
    }

    setPrevious() {
        const page = this.state.pager.currentPage - 1;

        var { items, pageSize } = this.props;
        var pager = this.state.pager;

        if (page < 1 || page > pager.totalPages) {
            return;
        }

        // get new pager object for specified page
        pager = this.getPager(items.length, page, pageSize);

        // get new page of items from items array
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update state
        this.setState({ pager: pager });

        // call change page function in parent component
        this.props.onChangePage(pageOfItems);
    }

    setNext() {
        const page = this.state.pager.currentPage + 1;

        var { items, pageSize } = this.props;
        var pager = this.state.pager;

        if (page < 1 || page > pager.totalPages) {
            console.log('page < 1 || page > pager.totalPages');
            return;
        }

        // get new pager object for specified page
        pager = this.getPager(items.length, page, pageSize);

        // get new page of items from items array
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update state
        this.setState({ pager: pager });

        // call change page function in parent component
        this.props.onChangePage(pageOfItems);
    }

    getPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 10
        pageSize = pageSize || 10;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    render() {
      var pager = this.state.pager;

      if (!pager.pages || pager.pages.length <= 1) {
          // don't display pager if there is only 1 page
          return null;
      }

      return (
        <PaginationWrapper>
          {
            this.props.showStepNavigator ? (
              <ul className="step-navigator" style={{ position: 'absolute', top: 175 }}>
                  {
                      pager.currentPage !== 1 ? (
                          <li className="left"><button className="previous" onClick={() => this.setPrevious()}><i className="fa fa-chevron-left"></i></button></li>
                      ) : null
                  }
                  {
                      pager.currentPage !== pager.totalPages ? (
                          <li className="right"><button className="next" onClick={() => this.setNext()}><i className="fa fa-chevron-right"></i></button></li>
                      ) : null
                  }
              </ul>
            ) : null
          }
          <ul className="pagination hide-scrollbars">
            <li className={pager.currentPage === 1 ? 'disabled' : ''}>
                <a onClick={() => this.setPage(1)}>
                  <i className="material-icons" style={{ transform: 'rotate(180deg)' }}>arrow_right_alt</i>
                </a>
            </li>
            <li className={pager.currentPage === 1 ? 'disabled' : ''}>
                <a onClick={() => this.setPage(pager.currentPage - 1)}>
                  <i className="material-icons">chevron_left</i>
                </a>
            </li>
            {pager.pages.map((page, index) =>
                <li key={index} className={pager.currentPage === page ? 'active' : ''}>
                    <a onClick={() => this.setPage(page)}>{page}</a>
                </li>
            )}
            <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
                <a onClick={() => this.setPage(pager.currentPage + 1)}>
                  <i className="material-icons">chevron_right</i>
                </a>
            </li>
            <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
                <a onClick={() => this.setPage(pager.totalPages)}>
                  <i className="material-icons">arrow_right_alt</i>
                </a>
            </li>
          </ul>
        </PaginationWrapper>
      );
    }
}

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
export default Pagination;

// http://jasonwatmore.com/post/2017/03/14/react-pagination-example-with-logic-like-google
